import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['form', 'comment', 'heading'];
  static values = {
    actionTemplate: String,
  };

  initialize() {
    this.onShow = this.onShow.bind(this);
    $(this.element).on('show.bs.modal', this.onShow);
  }

  disconnect() {
    $(this.element).off('show.bs.modal', this.onShow);
  }

  onShow(event) {
    const trigger = event.relatedTarget;
    if (!trigger) return;

    const auditId = trigger.dataset.auditId || '';
    const comment = trigger.dataset.auditComment || '';
    const version = trigger.dataset.auditVersion || '';

    this.formTarget.action = this.actionTemplateValue.replace('__AUDIT_ID__', auditId);
    this.commentTarget.value = comment;

    if (this.hasHeadingTarget) {
      this.headingTarget.textContent = version ? `Comment on audit #${version}` : 'Audit comment';
    }

    setTimeout(() => this.commentTarget.focus(), 50);
  }
}
